import {
    CREATE_CHECKING_DC_DETAILS_REQUEST,
    CREATE_CHECKING_DC_DETAILS_SUCCESS,
    CREATE_CHECKING_DC_DETAILS_FAILURE,
    DELETE_CHECKING_DC_DETAILS_REQUEST,
    DELETE_CHECKING_DC_DETAILS_SUCCESS,
    DELETE_CHECKING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_CHECKING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_CHECKING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_CHECKING_DC_DETAILS_FAILURE,
    FETCH_CHECKING_DC_DETAILS_REQUEST,
    FETCH_CHECKING_DC_DETAILS_SUCCESS,
    FETCH_CHECKING_DC_DETAILS_FAILURE,
    UPDATE_CHECKING_DC_DETAILS_REQUEST,
    UPDATE_CHECKING_DC_DETAILS_SUCCESS,
    UPDATE_CHECKING_DC_DETAILS_FAILURE,
    RESET_CHECKING_DC_DETAILS_INFO,
    CREATE_CHECKING_DC_DETAILS_FORM,
    UPDATE_CHECKING_DC_DETAILS_FORM,
    FETCH_CHECKING_DC_DETAILS_WITHOUT_ID_SUCCESS
} from './checkingDcDetails.actionsType';

export const CHECKING_DC_DETAILS = 'checkingDcDetails';

let initialState = {
    loading: false,
    checkingDcDetails: [],
    checkingDcDetailsWithoutId: [],
    sleeveType: [],
    neckType: [],
    printType: [],
    catalogueNameList: [],
    userform: {},
    selectedState: {},
    errorMessage: ''
};

export let checkingDcDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CHECKING_DC_DETAILS_REQUEST:
        case CREATE_CHECKING_DC_DETAILS_REQUEST:
        case UPDATE_CHECKING_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_CHECKING_DC_DETAILS_REQUEST:
        case DELETE_CHECKING_DC_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CHECKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcDetails: updatePayload
            };
        case FETCH_CHECKING_DC_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcDetailsWithoutId: updatePayload
            };
        case CREATE_CHECKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case UPDATE_CHECKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_CHECKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case DELETE_CHECKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case RESET_CHECKING_DC_DETAILS_INFO:
            return {
                ...state,
                userform: {}
            };
        case CREATE_CHECKING_DC_DETAILS_FORM:
        case UPDATE_CHECKING_DC_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CHECKING_DC_DETAILS_FAILURE:
        case CREATE_CHECKING_DC_DETAILS_FAILURE:
        case UPDATE_CHECKING_DC_DETAILS_FAILURE:
        case FETCH_SINGLE_CHECKING_DC_DETAILS_FAILURE:
        case DELETE_CHECKING_DC_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
